function _instanceof(left, right) {
  return null != right && "undefined" != typeof Symbol && right[Symbol.hasInstance] ? right[Symbol.hasInstance](left) : left instanceof right;
}

function _classCallCheck(instance, Constructor) {
  if (!_instanceof(instance, Constructor)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(target, props) {
  for (var descriptor, i = 0; i < props.length; i++) {
    descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  return protoProps && _defineProperties(Constructor.prototype, protoProps), staticProps && _defineProperties(Constructor, staticProps), Constructor;
}

import assert from "./assert";
import { LinearInterpolator } from "./transition";
import MapState from "./map-state";

var noop = function noop() {};

export var TRANSITION_EVENTS = {
  BREAK: 1,
  SNAP_TO_END: 2,
  IGNORE: 3
};

var DEFAULT_PROPS = {
  transitionDuration: 0,
  transitionEasing: function transitionEasing(t) {
    return t;
  },
  transitionInterpolator: new LinearInterpolator(),
  transitionInterruption: TRANSITION_EVENTS.BREAK,
  onTransitionStart: noop,
  onTransitionInterrupt: noop,
  onTransitionEnd: noop
},
    DEFAULT_STATE = {
  animation: null,
  propsInTransition: null,
  startProps: null,
  endProps: null
},
    TransitionManager = function () {
  function TransitionManager(props) {
    _classCallCheck(this, TransitionManager), this.props = props, this.state = DEFAULT_STATE, this._onTransitionFrame = this._onTransitionFrame.bind(this);
  }

  return _createClass(TransitionManager, [{
    key: "getViewportInTransition",
    value: function getViewportInTransition() {
      return this.state.propsInTransition;
    }
  }, {
    key: "processViewportChange",
    value: function processViewportChange(nextProps) {
      var transitionTriggered = !1,
          currentProps = this.props;
      if (this.props = nextProps, this._shouldIgnoreViewportChange(currentProps, nextProps)) return transitionTriggered;

      var isTransitionInProgress = this._isTransitionInProgress();

      if (this._isTransitionEnabled(nextProps)) {
        var startProps = Object.assign({}, currentProps, this.state.interruption === TRANSITION_EVENTS.SNAP_TO_END ? this.state.endProps : this.state.propsInTransition);
        isTransitionInProgress && currentProps.onTransitionInterrupt(), nextProps.onTransitionStart(), this._triggerTransition(startProps, nextProps), transitionTriggered = !0;
      } else isTransitionInProgress && (currentProps.onTransitionInterrupt(), this._endTransition());

      return transitionTriggered;
    }
  }, {
    key: "_isTransitionInProgress",
    value: function _isTransitionInProgress() {
      return !!this.state.propsInTransition;
    }
  }, {
    key: "_isTransitionEnabled",
    value: function _isTransitionEnabled(props) {
      return 0 < props.transitionDuration && !!props.transitionInterpolator;
    }
  }, {
    key: "_isUpdateDueToCurrentTransition",
    value: function _isUpdateDueToCurrentTransition(props) {
      return !!this.state.propsInTransition && this.state.interpolator.arePropsEqual(props, this.state.propsInTransition);
    }
  }, {
    key: "_shouldIgnoreViewportChange",
    value: function _shouldIgnoreViewportChange(currentProps, nextProps) {
      return this._isTransitionInProgress() ? this.state.interruption === TRANSITION_EVENTS.IGNORE || this._isUpdateDueToCurrentTransition(nextProps) : !this._isTransitionEnabled(nextProps) || nextProps.transitionInterpolator.arePropsEqual(currentProps, nextProps);
    }
  }, {
    key: "_triggerTransition",
    value: function _triggerTransition(startProps, endProps) {
      assert(this._isTransitionEnabled(endProps), "Transition is not enabled"), cancelAnimationFrame(this.state.animation);
      var initialProps = endProps.transitionInterpolator.initializeProps(startProps, endProps);
      this.state = {
        duration: endProps.transitionDuration,
        easing: endProps.transitionEasing,
        interpolator: endProps.transitionInterpolator,
        interruption: endProps.transitionInterruption,
        startTime: Date.now(),
        startProps: initialProps.start,
        endProps: initialProps.end,
        animation: null,
        propsInTransition: {}
      }, this._onTransitionFrame();
    }
  }, {
    key: "_onTransitionFrame",
    value: function _onTransitionFrame() {
      this.state.animation = requestAnimationFrame(this._onTransitionFrame), this._updateViewport();
    }
  }, {
    key: "_endTransition",
    value: function _endTransition() {
      cancelAnimationFrame(this.state.animation), this.state = DEFAULT_STATE;
    }
  }, {
    key: "_updateViewport",
    value: function _updateViewport() {
      var currentTime = Date.now(),
          _this$state = this.state,
          startTime = _this$state.startTime,
          duration = _this$state.duration,
          easing = _this$state.easing,
          interpolator = _this$state.interpolator,
          startProps = _this$state.startProps,
          endProps = _this$state.endProps,
          shouldEnd = !1,
          t = (currentTime - startTime) / duration;
      1 <= t && (t = 1, shouldEnd = !0), t = easing(t);
      var viewport = interpolator.interpolateProps(startProps, endProps, t),
          mapState = new MapState(Object.assign({}, this.props, viewport));
      this.state.propsInTransition = mapState.getViewportProps();
      var onViewportChange = this.props.onViewportChange || this.props.onChangeViewport;
      onViewportChange && onViewportChange(this.state.propsInTransition), this.props.onViewStateChange && this.props.onViewStateChange({
        viewState: this.state.propsInTransition
      }), shouldEnd && (this._endTransition(), this.props.onTransitionEnd());
    }
  }]), TransitionManager;
}();

export { TransitionManager as default };
TransitionManager.defaultProps = DEFAULT_PROPS;